import api from './axios';

/** ===================== 공정(Activities) ===================== **/
export const SaveFromFile = (project_id, file_path, with_baseline = true) =>
  api.post("process/imports/save/from-file/", { project_id, file_path, with_baseline, });

// 파일 업로드 (FormData)
export const uploadProcessFile = (file, withBaseline = false, baselineCode = "", cutoffDate, sourceType, acEqBa) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("data_date", cutoffDate);
  formData.append("with_baseline", withBaseline ? "true" : "false");
  formData.append("source_type", sourceType);
  formData.append("ac_eq_ba", acEqBa ? "true" : "false");
  if (withBaseline || acEqBa) {
    formData.append("revision", baselineCode);
  }


  return api.post("/process/imports/save/from-upload/", formData, {
    headers: { "Content-Type": undefined },
  });
};

// 공정표(Primavera) 데이터 조회 (이미 있는 엔드포인트)
export const getPrimavera = (project) =>
  api.get('process/get/primavera/', { params: { project } }).then(res => res.data);

// 공정표 (Gantt) 데이터 조회
export const getGanttData = (project) =>
  api.get("/process/gantt/", { params: { project } }).then(res => res.data);

// 공정 진도율 데이터 조회
export const getProgress = (actual = null, baseline = null) =>
  api.get("/process/progress/", { params: { actual, baseline } }).then (res => res.data);

export const getProgressSummary = (actual = null, baseline = null) =>
  api.get("/process/progress/summary/", { params: { actual, baseline } }).then (res => res.data);


// 지연 공정 리스트 조회
export const getDelayedActivities = ({ page = 1, pageSize = 15 }) =>
  api.get("/process/delays/", { params: { page, page_size: pageSize } })
    .then(res => res.data);

// 공정 요약 정보 조회
export const getActivityView = (activityId) =>
  api.get(`/process/activity/${activityId}/view/`).then(res => res.data);

// 일정 변경 이력 조회
export const getChangeLogs = ({ projectId, page = 1, pageSize = 20 }) =>
  api.get("/process/changelogs/", { params: { page, page_size: pageSize } }).then(res => res.data);

//특정 날짜 activity 불러오기
export const getActivitiesByDate = (date) =>
  api
    .get(`/process/activity/date/`, { params: { date } })
    .then((res) => res.data.results || res.data);

export const getUpdateRunList = async () => {
  const res = await api.get(`/process/updateruns/`);
  return res.data;
};

export const deleteUpdateRun = async (id) => {
  const res = await api.delete(`/process/update-runs/${id}/`);
  return res.data;
};

export const getMilestoneTrend = async (baseline) => {
  const res = await api.get(`/process/mta/`, { params: { baseline } });
  return res.data;
};

export const getSummary = async () => {
  const res = await api.get(`/process/summary/`);
  return res.data;
}

export const getMilestones = async () => {
  const res = await api.get(`/process/milestones/`,);
  return res.data;
}

export const saveMilestoneSettings = async ( visibleIds) => {
  const res = await api.post(`/process/milestones/save/`, {
    visible_ids: visibleIds,
  });
  return res.data;
};

export const getMilestoneSettings = async () => {
  const res = await api.get(`/process/milestones/list/`,);
  return res.data;
}